import { lazy, Suspense } from 'react';
import { PanelSkeleton } from './components/ui';

const Page = lazy(() => import('./inventory-page').then((m) => ({ default: m.InventoryPage })));

/** Tela de estoque carregada sob demanda (a rota e a permissão ficam em app/routes.tsx). */
export const InventoryRoute = () => (
  <Suspense fallback={<PanelSkeleton rows={4} />}>
    <Page />
  </Suspense>
);
